<template>
    <div class="card">
        <div class="card-body" v-if="chartOptions">
            <p class="chart-title">{{ label }}</p>
            <apexcharts v-if="isReady" :key="chartKey" width="500" height="350" type="pie" :options="chartOptions"
                :series="series" />
        </div>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
export default {
    components: { apexcharts: VueApexCharts },
    props: {
        chartData: { type: Object, required: true },
        label: { type: String, required: true },
        colors: {type: Array, required: false}
    },
    computed: {
        series() {
            return this.chartData.series || [];
        },
        chartOptions() {
            
            return {
                chart: { width: 500, type: 'pie' },
                labels: this.chartData.labels || [],
                legend: { position: 'bottom' },
                colors: this.colors || ["#3b5de7", "#5f80ec", "#263ea1", "#bac8f6", "#3bd0e7"],
                responsive: [{
                    breakpoint: 480,
                    options: { chart: { width: 200 }, legend: { position: "bottom" } }
                }]
            };
        },
        isReady() {
            return Array.isArray(this.chartData.series) &&
                this.chartData.series.length > 0 &&
                Array.isArray(this.chartData.labels) &&
                this.chartData.labels.length > 0;
        },
        chartKey() {
            // Isso força re-montagem real, se necessário:
            return JSON.stringify(this.series) + JSON.stringify(this.chartOptions.labels);
        }
    }
}
</script>
<style>
.apexcharts-canvas{
    margin: 0 auto !important;
}
</style>
